/**
 * Floor plan / heatmap “chrome” behind map content (letterboxing, capture canvas, PDF frame).
 * Keep in sync with `.heatmap-img-wrap` in
 * `nextera-api/nextera_api/rest_apis/views/projects/templates/safety_report/full_report.html`.
 */
export const FLOOR_PLAN_CHROME = '#f8f8f8'
